import Box from '@mui/material/Box';
import Button from '@mui/material/Button';
import Typography from '@mui/material/Typography';

import { brand } from '../theme';

/**
 * Shown when WordPress could not be reached.
 *
 * The phone number is hardcoded here on purpose. Everywhere else it comes from
 * the REST API, but this screen exists precisely because that request failed,
 * so a visitor who hits it still gets a way to make contact.
 */
export default function ErrorScreen({ error }) {
	return (
		<Box
			sx={{
				minHeight: '100vh',
				display: 'grid',
				placeItems: 'center',
				textAlign: 'center',
				backgroundColor: brand.dark,
				color: brand.textInvert,
				px: 3,
			}}
		>
			<Box sx={{ maxWidth: '34rem' }}>
				<Typography variant="h2" sx={{ color: brand.white, mb: 2 }}>
					We could not load the site
				</Typography>

				<Typography sx={{ color: brand.textInvertMuted, mb: 4 }}>
					Something went wrong at our end. Please try again in a moment — or just call us, we are
					happy to talk it through.
				</Typography>

				<Box sx={{ display: 'flex', gap: 2, justifyContent: 'center', flexWrap: 'wrap' }}>
					<Button variant="contained" color="primary" href="tel:+17806917454">
						Call +1 (780) 691-7454
					</Button>
					<Button
						variant="outlined"
						sx={{ color: brand.textInvert, borderColor: brand.lineLight }}
						onClick={() => window.location.reload()}
					>
						Try again
					</Button>
				</Box>

				{import.meta.env.DEV && error ? (
					<Typography
						component="pre"
						sx={{
							mt: 5,
							p: 2,
							textAlign: 'left',
							fontSize: '0.8rem',
							color: brand.accentSoft,
							backgroundColor: brand.darkDeep,
							borderRadius: 1,
							overflowX: 'auto',
						}}
					>
						{error.message}
					</Typography>
				) : null}
			</Box>
		</Box>
	);
}
